
































import Vue from 'vue';
import MpGroupField from './MpGroupField.vue';
import massVuex from '../../vuex/common';
import Locations from '../../../common/utils/Location';
import ContainRelation from './ContainRelation.vue';
import { AreaFilter } from '../../../customer/models/CustomerFilter';

const areaData: Loc[] = [
  {
    value: '中国',
    label: '中国',
    loading: false,
    children: [],
  },
  {
    value: '海外',
    label: '海外',
    loading: false,
    children: [],
  },
];

interface Loc {
  value: string;
  label: string;
  loading?: boolean;
  children?: Loc[];
}

export default Vue.extend({
  mixins: [massVuex],
  components: {
    MpGroupField,
    ContainRelation,
  },
  props: {
    areas: {
      type: Array,
      default: (): any => [],
    },
  },
  data() {
    return {
      areaData,
    };
  },
  methods: {
    liftLocations(locs: any, isRoot: boolean, depth: number): Loc[] {
      const arrs: Loc[] = !isRoot ? [{
        value: '所有',
        label: '所有',
      }] : [];
      if (Array.isArray(locs)) {
        for (const loc of locs) {
          arrs.push({
            value: loc,
            label: loc,
          });
        }
      } else {
        Object.keys(locs).forEach((k) => {
          const l = locs[k];
          if (Object.keys(l) && Object.keys(l).length > 0 && depth < 2) {
            arrs.push({
              value: k,
              label: k,
              children: this.liftLocations(l, false, depth + 1),
            });
          } else {
            arrs.push({
              value: k,
              label: k,
            });
          }
        });
      }
      return arrs;
    },
    addArea() {
      const v = this.customerFilter.area;
      v.areas.push([]);
      this.updateAreaFilter(v);
    },
    deleteArea() {
      const v = this.customerFilter.area;
      v.areas.splice(v.areas.length - 1, 1);
      this.updateAreaFilter(v);
    },
    updateNotIn(notIn: boolean) {
      const v = this.customerFilter.area;
      v.notIn = notIn;
      this.updateAreaFilter(v);
    },
    updateArea(key: number, value: string[]) {
      const v = this.customerFilter.area;
      v.areas[key] = value;
      this.updateAreaFilter(v);
    },
    updateAreaFilter(filter: AreaFilter) {
      this.$store.commit('UPDATE_CUSTOMER_FILTER', {
        key: 'area',
        value: filter,
      });
    },
    loadData(item: Loc, callback: () => {}) {
      const locs: {[index: string]: any} = Locations;
      item.loading = true;
      item.children = this.liftLocations(locs[item.value], false, 1);
      item.loading = false;
      callback();
    },
  },
});
